import { render, staticRenderFns } from "./aboutMemberModel.vue?vue&type=template&id=549d5940&scoped=true&lang=pug&"
import script from "./aboutMemberModel.vue?vue&type=script&lang=js&"
export * from "./aboutMemberModel.vue?vue&type=script&lang=js&"
import style0 from "./aboutMemberModel.vue?vue&type=style&index=0&id=549d5940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d5940",
  null
  
)

export default component.exports